<div class="mt-4">
  <ol class="breadcrumb bg-white">
    <li class="breadcrumb-item"><button class="btn btn-sm btn-link" disabled>Cartes cadeaux</button></li>
  </ol>
</div>


<div class="my-3 p-3 bg-white rounded shadow-sm">
  <table class="table table-sm text-center" *ngIf="giftCardAlerts">
    <thead>
      <tr>
        <th>Client</th>
        <th>Date</th>
        <th>Montant des achats</th>
        <th>Montant carte cadeau</th>
        <th>&nbsp;</th>
      </tr>
      <tr *ngIf="giftCardAlerts.length == 0">
        <td colspan="5">Aucune carte cadeau à préparer</td>
      </tr>

      <tr *ngFor="let giftCardAlert of giftCardAlerts">
        <td>
          <a [attr.href]="companyInfo.shopifyAdminUrl + '/customers/' + giftCardAlert.shopifyCustomerId" 
             target="_blank"
          >
            {{ giftCardAlert.shopifyCustomerName }}
            <a *ngIf="giftCardAlert.shopifyEmail != null">
              <a *ngIf="giftCardAlert.shopifyCustomerName != null">-</a>
              {{ giftCardAlert.shopifyEmail }}
            </a>
          </a>
        </td>
        <td>{{ giftCardAlert.creationTimestamp | date:'yyyy-MM-dd HH:mm:ss' }}</td>
        <td>
          <a class="btn-link" (click)='showDetails(giftCardAlert, details)'>
            {{ giftCardAlert.amount / 100 }} $
          </a>
        </td>
        <td>
          {{ giftCardAlert.amount / 100 * 0.05 | number : '1.2-2' }} $
        </td>
        <td>
          <button class="btn btn-sm btn-success" (click)='showDetails(giftCardAlert, details)'><i class="bi bi-check"></i></button>
        </td>
      </tr>
    </thead>
  </table>
</div>

<ng-template #confirm let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Valider la carte cadeaux</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>
      Shopify ne permet pas à Kubik de créer automatiquement les cardeaux. Veuillez confirmer une fois que vous avec une nouvelle
      <a [href]="companyInfo.shopifyAdminUrl + '/gift_cards'" target="_blank">carte cadeau</a> pour
      <a [attr.href]="companyInfo.shopifyAdminUrl + '/customers/' + selectedGiftCardAlert.shopifyCustomerId" target="_blank">
        {{ selectedGiftCardAlert.shopifyCustomerName }}
        <a *ngIf="selectedGiftCardAlert.shopifyEmail != null">
          <a *ngIf="selectedGiftCardAlert.shopifyCustomerName != null">-</a>
          {{ selectedGiftCardAlert.shopifyEmail }}
        </a>
      </a>.
    </p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="modal.dismiss()">Annuler</button>
    <button type="button" class="btn btn-outline-success" (click)="modal.close()">Valider</button>
  </div>
</ng-template>

<ng-template #details let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Commandes clients</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>Voice les ventes ayant servis à calculer la carte cadeaux pour le client
      <a [attr.href]="companyInfo.shopifyAdminUrl + '/customers/' + selectedGiftCardAlert.shopifyCustomerId" target="_blank">
        {{ selectedGiftCardAlert.shopifyCustomerName }}
        <a *ngIf="selectedGiftCardAlert.shopifyEmail != null">
          <a *ngIf="selectedGiftCardAlert.shopifyCustomerName != null">-</a>
          {{ selectedGiftCardAlert.shopifyEmail }}
        </a>
      </a>.
    </p>

    <table class="table table-sm text-center" *ngIf="customerOrders">
      <thead>
        <tr>
          <th>
            Commande Shopify
          </th>
          <th>
            Montant
          </th>
          <th>
            Date
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let customerOrder of customerOrders">
          <td>
            <a 
              [attr.href]="companyInfo.shopifyAdminUrl + '/orders/' + customerOrder.shopifyNumber" 
              target="_blank"
            >
              {{customerOrder.shopifyNumber}}
            </a>
          </td>
          <td>
            {{ customerOrder.amount / 100 }} $
          </td>
          <td>{{ customerOrder.orderDate | date:'yyyy-MM-dd HH:mm:ss' }}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="modal.dismiss()">Fermer</button>
  </div>
</ng-template>